import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function AccessDeniedUI() {
  const navigate = useNavigate();

  return (
    <Box
      display="flex" alignItems="center" justifyContent="center"
      height="calc(100vh - 71px - 143px)"
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap="18px" maxWidth="360px" textAlign="center">
        
        <Box sx={{
          width: 88, height: 88, borderRadius: '50%',
          background: 'rgba(242,103,74,0.1)',
          border: '1.5px solid rgba(242,103,74,0.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <Box sx={{
            width: 56, height: 56, borderRadius: '50%',
            background: 'rgba(242,103,74,0.18)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C9.24 2 7 4.24 7 7v2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2h-2V7c0-2.76-2.24-5-5-5zm0 2c1.66 0 3 1.34 3 3v2H9V7c0-1.66 1.34-3 3-3zm0 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" fill="#F2674A"/>
            </svg>
          </Box>
        </Box>

        <Box sx={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          background: 'rgba(242,103,74,0.1)', border: '1px solid rgba(242,103,74,0.25)',
          borderRadius: '20px', padding: '5px 14px',
          fontSize: 12, fontWeight: 600, color: '#F2674A'
        }}>
          Access Restricted
        </Box>

        <Typography sx={{ fontSize: 20, fontWeight: 600, color: 'white', letterSpacing: '-0.2px' }}>
          You can't view this content
        </Typography>

        <Box sx={{ width: 48, height: 1.5, background: 'rgba(242,103,74,0.25)', borderRadius: 1 }} />

        <Typography sx={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', lineHeight: 1.6 }}>
          You don't have permission to view this user's activity.
        </Typography>

        <Button
          className="btn btn-primary"
          onClick={() => navigate('/myprofile')}
          sx={{ borderRadius: '50px', padding: '12px 36px', fontSize: 14, fontWeight: 600 }}
        >
          Go to My Profile
        </Button>
      </Box>
    </Box>
  );
}